export default function Header() {
    return (
        <>
            <div>
                <nav style={{backgroundColor: "var(--main-color) !important"}} className="navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-dark justify-content-center" >
                    <div className="text-center m-2">
                        <h2 style={{fontWeight: 'bold'}} className="text-white text-center">شركة إثراء للتعليم</h2>
                    </div>
                </nav>
            </div>
        </>
    );
}